export default __webpack_public_path__ + "static/media/81.3f9b9c4a.png";